var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({class:['product-inshowroom', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id}},'div',_vm.data.attrs,false),[_c('b-icon',{attrs:{"icon":"house","variant":"dark"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }